var IconButton    = require("app/ui/IconButton"),
    frameThrottle = require("enyo-perf/utils").frameThrottle,
    get           = require("object-path").get,
    icons         = require("app/theme/icons"),
    kind          = require("enyo/kind");

require("app/theme/IconButton--filter-bar.less");
require("app/theme/IconButton--filter-bar-dropdown.less");

module.exports = kind(/** @lends  app.SearchPage.TypeFilterButton.prototype */ {

    /**
     * @private
     */
    name: "app.SearchPage.TypeFilterButton",

    /**
     * @private
     */
    kind: IconButton,

    /**
     * @private
     */
    classes: "app-search-page-type-filter-button",

    /**
     * The dataset
     *
     * @type  {?Object}
     * @public
     */
    data: null,

    /**
     * Align the icon on the left or the right.
     *
     * @type  {?string}
     * @public
     */
    iconAlignment: "left",

    /**
     * @private
     */
    observers: {
        update: ["data"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var i18nService = this.app.$.i18nService,
            data        = this.data || {};

        this.set("caption", i18nService.getString("app.SearchPage.SearchForm.TypeFilterButton.caption", {
            type: get(data, "type", null) || "all"
        }) || "");

        if (get(data, "active", false)) {
            !this.hasClass("active") && this.addClass("active");
            this.set("icon", icons["app.SearchPage.SearchForm.TypeFilterButton.active"]);
        }
        else {
            while (this.hasClass("active")) {
                this.removeClass("active");
            }
            this.set("icon", icons["app.SearchPage.SearchForm.TypeFilterButton.inactive"]);
        }
    },

    /**
     * Request an updated search
     *
     * @return  {boolean}  Stop propagation
     * @private
     */
    tap: function() {
        var data = this.data || {};

        this.bubbleUp("requestTypeFilter", {
            type: get(data, "type", null)
        });

        return true;
    }

});
